var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"ml-[-2px]",attrs:{"width":"23","height":"23","viewBox":"0 0 23 23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M5.825 21.0833L7.45 14.351L2 9.82292L9.2 9.22396L12 2.875L14.8 9.22396L22 9.82292L16.55 14.351L18.175 21.0833L12 17.5135L5.825 21.0833Z","fill":_vm.color}})])
}
var staticRenderFns = []

export { render, staticRenderFns }